import i18n, { type Resource } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const options = {
    order: [
        'localStorage',
        'querystring',
        'cookie',
        'sessionStorage',
        'navigator',
        'htmlTag',
    ],
}

const initializeI18n = (locales: Resource): void => {
    const supportedLngs = Object.keys(locales)

    void (i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            detection: {
                ...options,
                // Unsupported languages become 'en' so they do not fall through to a later supported browser language
                convertDetectedLanguage: (lng: string) => {
                    const code = lng.split('-')[0]
                    return supportedLngs.includes(code) ? code : 'en'
                },
            },
            fallbackLng: 'en',
            supportedLngs,
            resources: locales,
            react: {
                useSuspense: false,
            },
            interpolation: {
                escapeValue: false,
            },
            defaultNS: 'body',
        }))
}

export { i18n, initializeI18n }
